import React, { useState } from "react";
import * as styles from "./style.mod.scss";
import { Container, Accordion, Card } from "react-bootstrap";
import Link from "components/link";
import getImagePath from "helpers/get-image-path";
import RichText from "components/rich-text";
import { ChevronDown } from "react-bootstrap-icons";

const BigImageText = ({ data }) => {
  const [open, setOpen] = useState(1);

  return (
    <div className={styles.bigImageText} style={{ backgroundColor: data?.bgColor && data?.bgColor?.hex }}>
      <Container>
        <div className={styles.innerContainer}>
          {(data?.headline || data?.description) && 
          <div className={styles.textContainer}>
            {data?.headline &&
              <h3 className={styles.bigImgHeadline} style={{ color: data?.textColor && data?.textColor?.hex }}>{data?.headline}</h3>}
            {data?.description &&
              <div className={styles.textBox}>
                <p className={styles.bigImgText} style={{ color: data?.textColor && data?.textColor?.hex }}>{data?.description}</p>
              </div>}

            {data?.button?.btnLink &&
              <Link to={data?.button?.btnLink}>
                <div className={styles.buttonBox}>
                  {data?.button?.btnTitle}
                </div>
              </Link>}
          </div>}
          <div className={styles.imageContainer}>
            {data?.image &&<img className={styles.bigImage} src={getImagePath(data?.image)} alt={data?.image} />}
            
          </div>
          <div className={styles.lowerPart}>
            <div className={styles.lowerPartContainer}>
              <div className={styles.leftPart}>
                <RichText blocks={data?.textLeft} />
              </div>
              <div className={styles.rightPart}>
                <RichText blocks={data?.textRight} />
              </div>
            </div>

            <div className={styles.lowerPartMobile}>
              {data?.textRight &&
                <>
                  <Accordion.Toggle
                    as={Card.Header}
                    eventKey={open}
                    className={styles.toggleHeader}
                    onClick={() => setOpen(open === 1 ? null : 1)}
                  >
                    <div className={styles.accrodionTitleIcon}>
                      <div className={styles.leftPart}>
                        <RichText blocks={data?.textLeft} />
                      </div>
                      <span className={`${styles.accordionIcon} ${1 !== open ? styles.accordionIconOpen : ""}`}>
                        <ChevronDown />
                      </span>
                    </div>

                  </Accordion.Toggle>
                  <Accordion.Collapse eventKey={open}>
                    <Card.Body className={styles.accordionBody}>
                      <RichText
                        className={styles.description}
                        blocks={data?.textRight}
                      />
                    </Card.Body>
                  </Accordion.Collapse></>}
            </div>
          </div>
        </div>

      </Container>

    </div>
  );
};

export default BigImageText;